import { isPro } from 'amkit3-modules/utils/constant'
import packjson from '../../package.json'

export const getResRoot = () =>
  process.env.NODE_ENV === 'development'
    ? location.origin + location.pathname
    : process.env.TEST
    ? `https://test-hd.huya.com/web/${packjson.name}/test/${packjson.version}/`
    : `https://a.msstatic.com/huya/hd/web/${packjson.name}/${packjson.version}/`
